// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutUsRouteImport } from './routes/about-us'
import { Route as BgRouteImport } from './routes/bg'
import { Route as CompanyPresentationRouteImport } from './routes/company-presentation'
import { Route as ContactUsRouteImport } from './routes/contact-us'
import { Route as CookiePolicyRouteImport } from './routes/cookie-policy'
import { Route as IndustriesRouteImport } from './routes/industries'
import { Route as MediaAnalysisRouteImport } from './routes/media-analysis'
import { Route as MediaMonitoringRouteImport } from './routes/media-monitoring'
import { Route as Mlp20RouteImport } from './routes/mlp-2-0'
import { Route as PartnersRouteImport } from './routes/partners'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as RequestADemoRouteImport } from './routes/request-a-demo'
import { Route as WhoWeHelpRouteImport } from './routes/who-we-help'
import { Route as WhyPercepticaRouteImport } from './routes/why-perceptica'
import { Route as BgIndexRouteImport } from './routes/bg.index'
import { Route as BgAboutUsRouteImport } from './routes/bg.about-us'
import { Route as BgContactUsRouteImport } from './routes/bg.contact-us'
import { Route as BgCookiePolicyRouteImport } from './routes/bg.cookie-policy'
import { Route as BgIndustriesRouteImport } from './routes/bg.industries'
import { Route as BgMediaAnalysisRouteImport } from './routes/bg.media-analysis'
import { Route as BgMediaMonitoringRouteImport } from './routes/bg.media-monitoring'
import { Route as BgMlp20RouteImport } from './routes/bg.mlp-2-0'
import { Route as BgPartnersRouteImport } from './routes/bg.partners'
import { Route as BgPricingRouteImport } from './routes/bg.pricing'
import { Route as BgPrivacyPolicyRouteImport } from './routes/bg.privacy-policy'
import { Route as BgRequestADemoRouteImport } from './routes/bg.request-a-demo'
import { Route as BgWhoWeHelpRouteImport } from './routes/bg.who-we-help'
import { Route as BgWhyPercepticaRouteImport } from './routes/bg.why-perceptica'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as IndustriesAutomotiveRouteImport } from './routes/industries.automotive'
import { Route as IndustriesFintechRouteImport } from './routes/industries.fintech'
import { Route as IndustriesFmcgRouteImport } from './routes/industries.fmcg'
import { Route as IndustriesPharmaRouteImport } from './routes/industries.pharma'
import { Route as IndustriesRetailRouteImport } from './routes/industries.retail'
import { Route as MediaAnalysisCompetitiveIntelligenceRouteImport } from './routes/media-analysis.competitive-intelligence'
import { Route as MediaAnalysisCrisisMonitoringRouteImport } from './routes/media-analysis.crisis-monitoring'
import { Route as MediaAnalysisEmployerBrandingRouteImport } from './routes/media-analysis.employer-branding'
import { Route as MediaAnalysisFaqRouteImport } from './routes/media-analysis.faq'
import { Route as MediaAnalysisMarketResearchRouteImport } from './routes/media-analysis.market-research'
import { Route as MediaAnalysisReputationRouteImport } from './routes/media-analysis.reputation'
import { Route as MediaMonitoringIndexRouteImport } from './routes/media-monitoring.index'
import { Route as MediaMonitoringCoverageRouteImport } from './routes/media-monitoring.coverage'
import { Route as MediaMonitoringPlatformRouteImport } from './routes/media-monitoring.platform'
import { Route as ReportsIndexRouteImport } from './routes/reports.index'
import { Route as ReportsSlugRouteImport } from './routes/reports.$slug'
import { Route as WhoWeHelpIndexRouteImport } from './routes/who-we-help.index'
import { Route as WhoWeHelpBrandManagersRouteImport } from './routes/who-we-help.brand-managers'
import { Route as WhoWeHelpEmployerBrandingExpertsRouteImport } from './routes/who-we-help.employer-branding-experts'
import { Route as WhoWeHelpMediaAgenciesRouteImport } from './routes/who-we-help.media-agencies'
import { Route as WhoWeHelpPrAgencyRouteImport } from './routes/who-we-help.pr-agency'
import { Route as WhoWeHelpPrManagersRouteImport } from './routes/who-we-help.pr-managers'
import { Route as BgBlogIndexRouteImport } from './routes/bg.blog.index'
import { Route as BgBlogSlugRouteImport } from './routes/bg.blog.$slug'
import { Route as BgIndustriesAutomotiveRouteImport } from './routes/bg.industries.automotive'
import { Route as BgIndustriesFintechRouteImport } from './routes/bg.industries.fintech'
import { Route as BgIndustriesFmcgRouteImport } from './routes/bg.industries.fmcg'
import { Route as BgIndustriesPharmaRouteImport } from './routes/bg.industries.pharma'
import { Route as BgIndustriesRetailRouteImport } from './routes/bg.industries.retail'
import { Route as BgMediaAnalysisCompetitiveIntelligenceRouteImport } from './routes/bg.media-analysis.competitive-intelligence'
import { Route as BgMediaAnalysisCrisisMonitoringRouteImport } from './routes/bg.media-analysis.crisis-monitoring'
import { Route as BgMediaAnalysisEmployerBrandingRouteImport } from './routes/bg.media-analysis.employer-branding'
import { Route as BgMediaAnalysisFaqRouteImport } from './routes/bg.media-analysis.faq'
import { Route as BgMediaAnalysisMarketResearchRouteImport } from './routes/bg.media-analysis.market-research'
import { Route as BgMediaAnalysisReputationRouteImport } from './routes/bg.media-analysis.reputation'
import { Route as BgMediaMonitoringIndexRouteImport } from './routes/bg.media-monitoring.index'
import { Route as BgMediaMonitoringCoverageRouteImport } from './routes/bg.media-monitoring.coverage'
import { Route as BgMediaMonitoringPlatformRouteImport } from './routes/bg.media-monitoring.platform'
import { Route as BgReportsIndexRouteImport } from './routes/bg.reports.index'
import { Route as BgReportsSlugRouteImport } from './routes/bg.reports.$slug'
import { Route as BgWhoWeHelpIndexRouteImport } from './routes/bg.who-we-help.index'
import { Route as BgWhoWeHelpBrandManagersRouteImport } from './routes/bg.who-we-help.brand-managers'
import { Route as BgWhoWeHelpEmployerBrandingExpertsRouteImport } from './routes/bg.who-we-help.employer-branding-experts'
import { Route as BgWhoWeHelpMediaAgenciesRouteImport } from './routes/bg.who-we-help.media-agencies'
import { Route as BgWhoWeHelpPrAgencyRouteImport } from './routes/bg.who-we-help.pr-agency'
import { Route as BgWhoWeHelpPrManagersRouteImport } from './routes/bg.who-we-help.pr-managers'
import { Route as MediaMonitoringPlatformFaqRouteImport } from './routes/media-monitoring.platform_.faq'
import { Route as BgMediaMonitoringPlatformFaqRouteImport } from './routes/bg.media-monitoring.platform_.faq'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutUsRoute = AboutUsRouteImport.update({
            id: '/about-us',path: '/about-us',getParentRoute: () => rootRouteImport
          })
const BgRoute = BgRouteImport.update({
            id: '/bg',path: '/bg',getParentRoute: () => rootRouteImport
          })
const CompanyPresentationRoute = CompanyPresentationRouteImport.update({
            id: '/company-presentation',path: '/company-presentation',getParentRoute: () => rootRouteImport
          })
const ContactUsRoute = ContactUsRouteImport.update({
            id: '/contact-us',path: '/contact-us',getParentRoute: () => rootRouteImport
          })
const CookiePolicyRoute = CookiePolicyRouteImport.update({
            id: '/cookie-policy',path: '/cookie-policy',getParentRoute: () => rootRouteImport
          })
const IndustriesRoute = IndustriesRouteImport.update({
            id: '/industries',path: '/industries',getParentRoute: () => rootRouteImport
          })
const MediaAnalysisRoute = MediaAnalysisRouteImport.update({
            id: '/media-analysis',path: '/media-analysis',getParentRoute: () => rootRouteImport
          })
const MediaMonitoringRoute = MediaMonitoringRouteImport.update({
            id: '/media-monitoring',path: '/media-monitoring',getParentRoute: () => rootRouteImport
          })
const Mlp20Route = Mlp20RouteImport.update({
            id: '/mlp-2-0',path: '/mlp-2-0',getParentRoute: () => rootRouteImport
          })
const PartnersRoute = PartnersRouteImport.update({
            id: '/partners',path: '/partners',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const RequestADemoRoute = RequestADemoRouteImport.update({
            id: '/request-a-demo',path: '/request-a-demo',getParentRoute: () => rootRouteImport
          })
const WhoWeHelpRoute = WhoWeHelpRouteImport.update({
            id: '/who-we-help',path: '/who-we-help',getParentRoute: () => rootRouteImport
          })
const WhyPercepticaRoute = WhyPercepticaRouteImport.update({
            id: '/why-perceptica',path: '/why-perceptica',getParentRoute: () => rootRouteImport
          })
const BgIndexRoute = BgIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BgRoute
          })
const BgAboutUsRoute = BgAboutUsRouteImport.update({
            id: '/about-us',path: '/about-us',getParentRoute: () => BgRoute
          })
const BgContactUsRoute = BgContactUsRouteImport.update({
            id: '/contact-us',path: '/contact-us',getParentRoute: () => BgRoute
          })
const BgCookiePolicyRoute = BgCookiePolicyRouteImport.update({
            id: '/cookie-policy',path: '/cookie-policy',getParentRoute: () => BgRoute
          })
const BgIndustriesRoute = BgIndustriesRouteImport.update({
            id: '/industries',path: '/industries',getParentRoute: () => BgRoute
          })
const BgMediaAnalysisRoute = BgMediaAnalysisRouteImport.update({
            id: '/media-analysis',path: '/media-analysis',getParentRoute: () => BgRoute
          })
const BgMediaMonitoringRoute = BgMediaMonitoringRouteImport.update({
            id: '/media-monitoring',path: '/media-monitoring',getParentRoute: () => BgRoute
          })
const BgMlp20Route = BgMlp20RouteImport.update({
            id: '/mlp-2-0',path: '/mlp-2-0',getParentRoute: () => BgRoute
          })
const BgPartnersRoute = BgPartnersRouteImport.update({
            id: '/partners',path: '/partners',getParentRoute: () => BgRoute
          })
const BgPricingRoute = BgPricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => BgRoute
          })
const BgPrivacyPolicyRoute = BgPrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => BgRoute
          })
const BgRequestADemoRoute = BgRequestADemoRouteImport.update({
            id: '/request-a-demo',path: '/request-a-demo',getParentRoute: () => BgRoute
          })
const BgWhoWeHelpRoute = BgWhoWeHelpRouteImport.update({
            id: '/who-we-help',path: '/who-we-help',getParentRoute: () => BgRoute
          })
const BgWhyPercepticaRoute = BgWhyPercepticaRouteImport.update({
            id: '/why-perceptica',path: '/why-perceptica',getParentRoute: () => BgRoute
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const IndustriesAutomotiveRoute = IndustriesAutomotiveRouteImport.update({
            id: '/automotive',path: '/automotive',getParentRoute: () => IndustriesRoute
          })
const IndustriesFintechRoute = IndustriesFintechRouteImport.update({
            id: '/fintech',path: '/fintech',getParentRoute: () => IndustriesRoute
          })
const IndustriesFmcgRoute = IndustriesFmcgRouteImport.update({
            id: '/fmcg',path: '/fmcg',getParentRoute: () => IndustriesRoute
          })
const IndustriesPharmaRoute = IndustriesPharmaRouteImport.update({
            id: '/pharma',path: '/pharma',getParentRoute: () => IndustriesRoute
          })
const IndustriesRetailRoute = IndustriesRetailRouteImport.update({
            id: '/retail',path: '/retail',getParentRoute: () => IndustriesRoute
          })
const MediaAnalysisCompetitiveIntelligenceRoute = MediaAnalysisCompetitiveIntelligenceRouteImport.update({
            id: '/competitive-intelligence',path: '/competitive-intelligence',getParentRoute: () => MediaAnalysisRoute
          })
const MediaAnalysisCrisisMonitoringRoute = MediaAnalysisCrisisMonitoringRouteImport.update({
            id: '/crisis-monitoring',path: '/crisis-monitoring',getParentRoute: () => MediaAnalysisRoute
          })
const MediaAnalysisEmployerBrandingRoute = MediaAnalysisEmployerBrandingRouteImport.update({
            id: '/employer-branding',path: '/employer-branding',getParentRoute: () => MediaAnalysisRoute
          })
const MediaAnalysisFaqRoute = MediaAnalysisFaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => MediaAnalysisRoute
          })
const MediaAnalysisMarketResearchRoute = MediaAnalysisMarketResearchRouteImport.update({
            id: '/market-research',path: '/market-research',getParentRoute: () => MediaAnalysisRoute
          })
const MediaAnalysisReputationRoute = MediaAnalysisReputationRouteImport.update({
            id: '/reputation',path: '/reputation',getParentRoute: () => MediaAnalysisRoute
          })
const MediaMonitoringIndexRoute = MediaMonitoringIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => MediaMonitoringRoute
          })
const MediaMonitoringCoverageRoute = MediaMonitoringCoverageRouteImport.update({
            id: '/coverage',path: '/coverage',getParentRoute: () => MediaMonitoringRoute
          })
const MediaMonitoringPlatformRoute = MediaMonitoringPlatformRouteImport.update({
            id: '/platform',path: '/platform',getParentRoute: () => MediaMonitoringRoute
          })
const ReportsIndexRoute = ReportsIndexRouteImport.update({
            id: '/reports/',path: '/reports/',getParentRoute: () => rootRouteImport
          })
const ReportsSlugRoute = ReportsSlugRouteImport.update({
            id: '/reports/$slug',path: '/reports/$slug',getParentRoute: () => rootRouteImport
          })
const WhoWeHelpIndexRoute = WhoWeHelpIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => WhoWeHelpRoute
          })
const WhoWeHelpBrandManagersRoute = WhoWeHelpBrandManagersRouteImport.update({
            id: '/brand-managers',path: '/brand-managers',getParentRoute: () => WhoWeHelpRoute
          })
const WhoWeHelpEmployerBrandingExpertsRoute = WhoWeHelpEmployerBrandingExpertsRouteImport.update({
            id: '/employer-branding-experts',path: '/employer-branding-experts',getParentRoute: () => WhoWeHelpRoute
          })
const WhoWeHelpMediaAgenciesRoute = WhoWeHelpMediaAgenciesRouteImport.update({
            id: '/media-agencies',path: '/media-agencies',getParentRoute: () => WhoWeHelpRoute
          })
const WhoWeHelpPrAgencyRoute = WhoWeHelpPrAgencyRouteImport.update({
            id: '/pr-agency',path: '/pr-agency',getParentRoute: () => WhoWeHelpRoute
          })
const WhoWeHelpPrManagersRoute = WhoWeHelpPrManagersRouteImport.update({
            id: '/pr-managers',path: '/pr-managers',getParentRoute: () => WhoWeHelpRoute
          })
const BgBlogIndexRoute = BgBlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => BgRoute
          })
const BgBlogSlugRoute = BgBlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => BgRoute
          })
const BgIndustriesAutomotiveRoute = BgIndustriesAutomotiveRouteImport.update({
            id: '/automotive',path: '/automotive',getParentRoute: () => BgIndustriesRoute
          })
const BgIndustriesFintechRoute = BgIndustriesFintechRouteImport.update({
            id: '/fintech',path: '/fintech',getParentRoute: () => BgIndustriesRoute
          })
const BgIndustriesFmcgRoute = BgIndustriesFmcgRouteImport.update({
            id: '/fmcg',path: '/fmcg',getParentRoute: () => BgIndustriesRoute
          })
const BgIndustriesPharmaRoute = BgIndustriesPharmaRouteImport.update({
            id: '/pharma',path: '/pharma',getParentRoute: () => BgIndustriesRoute
          })
const BgIndustriesRetailRoute = BgIndustriesRetailRouteImport.update({
            id: '/retail',path: '/retail',getParentRoute: () => BgIndustriesRoute
          })
const BgMediaAnalysisCompetitiveIntelligenceRoute = BgMediaAnalysisCompetitiveIntelligenceRouteImport.update({
            id: '/competitive-intelligence',path: '/competitive-intelligence',getParentRoute: () => BgMediaAnalysisRoute
          })
const BgMediaAnalysisCrisisMonitoringRoute = BgMediaAnalysisCrisisMonitoringRouteImport.update({
            id: '/crisis-monitoring',path: '/crisis-monitoring',getParentRoute: () => BgMediaAnalysisRoute
          })
const BgMediaAnalysisEmployerBrandingRoute = BgMediaAnalysisEmployerBrandingRouteImport.update({
            id: '/employer-branding',path: '/employer-branding',getParentRoute: () => BgMediaAnalysisRoute
          })
const BgMediaAnalysisFaqRoute = BgMediaAnalysisFaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => BgMediaAnalysisRoute
          })
const BgMediaAnalysisMarketResearchRoute = BgMediaAnalysisMarketResearchRouteImport.update({
            id: '/market-research',path: '/market-research',getParentRoute: () => BgMediaAnalysisRoute
          })
const BgMediaAnalysisReputationRoute = BgMediaAnalysisReputationRouteImport.update({
            id: '/reputation',path: '/reputation',getParentRoute: () => BgMediaAnalysisRoute
          })
const BgMediaMonitoringIndexRoute = BgMediaMonitoringIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BgMediaMonitoringRoute
          })
const BgMediaMonitoringCoverageRoute = BgMediaMonitoringCoverageRouteImport.update({
            id: '/coverage',path: '/coverage',getParentRoute: () => BgMediaMonitoringRoute
          })
const BgMediaMonitoringPlatformRoute = BgMediaMonitoringPlatformRouteImport.update({
            id: '/platform',path: '/platform',getParentRoute: () => BgMediaMonitoringRoute
          })
const BgReportsIndexRoute = BgReportsIndexRouteImport.update({
            id: '/reports/',path: '/reports/',getParentRoute: () => BgRoute
          })
const BgReportsSlugRoute = BgReportsSlugRouteImport.update({
            id: '/reports/$slug',path: '/reports/$slug',getParentRoute: () => BgRoute
          })
const BgWhoWeHelpIndexRoute = BgWhoWeHelpIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BgWhoWeHelpRoute
          })
const BgWhoWeHelpBrandManagersRoute = BgWhoWeHelpBrandManagersRouteImport.update({
            id: '/brand-managers',path: '/brand-managers',getParentRoute: () => BgWhoWeHelpRoute
          })
const BgWhoWeHelpEmployerBrandingExpertsRoute = BgWhoWeHelpEmployerBrandingExpertsRouteImport.update({
            id: '/employer-branding-experts',path: '/employer-branding-experts',getParentRoute: () => BgWhoWeHelpRoute
          })
const BgWhoWeHelpMediaAgenciesRoute = BgWhoWeHelpMediaAgenciesRouteImport.update({
            id: '/media-agencies',path: '/media-agencies',getParentRoute: () => BgWhoWeHelpRoute
          })
const BgWhoWeHelpPrAgencyRoute = BgWhoWeHelpPrAgencyRouteImport.update({
            id: '/pr-agency',path: '/pr-agency',getParentRoute: () => BgWhoWeHelpRoute
          })
const BgWhoWeHelpPrManagersRoute = BgWhoWeHelpPrManagersRouteImport.update({
            id: '/pr-managers',path: '/pr-managers',getParentRoute: () => BgWhoWeHelpRoute
          })
const MediaMonitoringPlatformFaqRoute = MediaMonitoringPlatformFaqRouteImport.update({
            id: '/platform_/faq',path: '/platform/faq',getParentRoute: () => MediaMonitoringRoute
          })
const BgMediaMonitoringPlatformFaqRoute = BgMediaMonitoringPlatformFaqRouteImport.update({
            id: '/platform_/faq',path: '/platform/faq',getParentRoute: () => BgMediaMonitoringRoute
          })





const BgIndustriesRouteChildren = {
  BgIndustriesAutomotiveRoute: BgIndustriesAutomotiveRoute,BgIndustriesFintechRoute: BgIndustriesFintechRoute,BgIndustriesFmcgRoute: BgIndustriesFmcgRoute,BgIndustriesPharmaRoute: BgIndustriesPharmaRoute,BgIndustriesRetailRoute: BgIndustriesRetailRoute
}

const BgIndustriesRouteWithChildren = BgIndustriesRoute._addFileChildren(BgIndustriesRouteChildren)




const BgMediaAnalysisRouteChildren = {
  BgMediaAnalysisCompetitiveIntelligenceRoute: BgMediaAnalysisCompetitiveIntelligenceRoute,BgMediaAnalysisCrisisMonitoringRoute: BgMediaAnalysisCrisisMonitoringRoute,BgMediaAnalysisEmployerBrandingRoute: BgMediaAnalysisEmployerBrandingRoute,BgMediaAnalysisFaqRoute: BgMediaAnalysisFaqRoute,BgMediaAnalysisMarketResearchRoute: BgMediaAnalysisMarketResearchRoute,BgMediaAnalysisReputationRoute: BgMediaAnalysisReputationRoute
}

const BgMediaAnalysisRouteWithChildren = BgMediaAnalysisRoute._addFileChildren(BgMediaAnalysisRouteChildren)




const BgMediaMonitoringRouteChildren = {
  BgMediaMonitoringCoverageRoute: BgMediaMonitoringCoverageRoute,BgMediaMonitoringPlatformRoute: BgMediaMonitoringPlatformRoute,BgMediaMonitoringIndexRoute: BgMediaMonitoringIndexRoute,BgMediaMonitoringPlatformFaqRoute: BgMediaMonitoringPlatformFaqRoute
}

const BgMediaMonitoringRouteWithChildren = BgMediaMonitoringRoute._addFileChildren(BgMediaMonitoringRouteChildren)




const BgWhoWeHelpRouteChildren = {
  BgWhoWeHelpBrandManagersRoute: BgWhoWeHelpBrandManagersRoute,BgWhoWeHelpEmployerBrandingExpertsRoute: BgWhoWeHelpEmployerBrandingExpertsRoute,BgWhoWeHelpMediaAgenciesRoute: BgWhoWeHelpMediaAgenciesRoute,BgWhoWeHelpPrAgencyRoute: BgWhoWeHelpPrAgencyRoute,BgWhoWeHelpPrManagersRoute: BgWhoWeHelpPrManagersRoute,BgWhoWeHelpIndexRoute: BgWhoWeHelpIndexRoute
}

const BgWhoWeHelpRouteWithChildren = BgWhoWeHelpRoute._addFileChildren(BgWhoWeHelpRouteChildren)



const BgRouteChildren = {
  BgAboutUsRoute: BgAboutUsRoute,BgContactUsRoute: BgContactUsRoute,BgCookiePolicyRoute: BgCookiePolicyRoute,BgIndustriesRoute: BgIndustriesRouteWithChildren,BgMediaAnalysisRoute: BgMediaAnalysisRouteWithChildren,BgMediaMonitoringRoute: BgMediaMonitoringRouteWithChildren,BgMlp20Route: BgMlp20Route,BgPartnersRoute: BgPartnersRoute,BgPricingRoute: BgPricingRoute,BgPrivacyPolicyRoute: BgPrivacyPolicyRoute,BgRequestADemoRoute: BgRequestADemoRoute,BgWhoWeHelpRoute: BgWhoWeHelpRouteWithChildren,BgWhyPercepticaRoute: BgWhyPercepticaRoute,BgIndexRoute: BgIndexRoute,BgBlogSlugRoute: BgBlogSlugRoute,BgReportsSlugRoute: BgReportsSlugRoute,BgBlogIndexRoute: BgBlogIndexRoute,BgReportsIndexRoute: BgReportsIndexRoute
}

const BgRouteWithChildren = BgRoute._addFileChildren(BgRouteChildren)




const IndustriesRouteChildren = {
  IndustriesAutomotiveRoute: IndustriesAutomotiveRoute,IndustriesFintechRoute: IndustriesFintechRoute,IndustriesFmcgRoute: IndustriesFmcgRoute,IndustriesPharmaRoute: IndustriesPharmaRoute,IndustriesRetailRoute: IndustriesRetailRoute
}

const IndustriesRouteWithChildren = IndustriesRoute._addFileChildren(IndustriesRouteChildren)




const MediaAnalysisRouteChildren = {
  MediaAnalysisCompetitiveIntelligenceRoute: MediaAnalysisCompetitiveIntelligenceRoute,MediaAnalysisCrisisMonitoringRoute: MediaAnalysisCrisisMonitoringRoute,MediaAnalysisEmployerBrandingRoute: MediaAnalysisEmployerBrandingRoute,MediaAnalysisFaqRoute: MediaAnalysisFaqRoute,MediaAnalysisMarketResearchRoute: MediaAnalysisMarketResearchRoute,MediaAnalysisReputationRoute: MediaAnalysisReputationRoute
}

const MediaAnalysisRouteWithChildren = MediaAnalysisRoute._addFileChildren(MediaAnalysisRouteChildren)




const MediaMonitoringRouteChildren = {
  MediaMonitoringCoverageRoute: MediaMonitoringCoverageRoute,MediaMonitoringPlatformRoute: MediaMonitoringPlatformRoute,MediaMonitoringIndexRoute: MediaMonitoringIndexRoute,MediaMonitoringPlatformFaqRoute: MediaMonitoringPlatformFaqRoute
}

const MediaMonitoringRouteWithChildren = MediaMonitoringRoute._addFileChildren(MediaMonitoringRouteChildren)




const WhoWeHelpRouteChildren = {
  WhoWeHelpBrandManagersRoute: WhoWeHelpBrandManagersRoute,WhoWeHelpEmployerBrandingExpertsRoute: WhoWeHelpEmployerBrandingExpertsRoute,WhoWeHelpMediaAgenciesRoute: WhoWeHelpMediaAgenciesRoute,WhoWeHelpPrAgencyRoute: WhoWeHelpPrAgencyRoute,WhoWeHelpPrManagersRoute: WhoWeHelpPrManagersRoute,WhoWeHelpIndexRoute: WhoWeHelpIndexRoute
}

const WhoWeHelpRouteWithChildren = WhoWeHelpRoute._addFileChildren(WhoWeHelpRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutUsRoute: AboutUsRoute,BgRoute: BgRouteWithChildren,CompanyPresentationRoute: CompanyPresentationRoute,ContactUsRoute: ContactUsRoute,CookiePolicyRoute: CookiePolicyRoute,IndustriesRoute: IndustriesRouteWithChildren,MediaAnalysisRoute: MediaAnalysisRouteWithChildren,MediaMonitoringRoute: MediaMonitoringRouteWithChildren,Mlp20Route: Mlp20Route,PartnersRoute: PartnersRoute,PricingRoute: PricingRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,RequestADemoRoute: RequestADemoRoute,WhoWeHelpRoute: WhoWeHelpRouteWithChildren,WhyPercepticaRoute: WhyPercepticaRoute,BlogSlugRoute: BlogSlugRoute,ReportsSlugRoute: ReportsSlugRoute,BlogIndexRoute: BlogIndexRoute,ReportsIndexRoute: ReportsIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)